import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import React__default from 'react';
import ReactDOM__default from 'react-dom';
import { dom } from '@bilibili-maoer/web-utils';
import { isGeneralMobile } from '../../utils/hooks.js';
import { ECommentType } from './enum.js';
export { ECommentType, ESortType } from './enum.js';
import { CommentsMobile } from './mobile/comments-mobile.js';
export { CommentsMobile } from './mobile/comments-mobile.js';
import { CommentsPC } from './pc/comments-pc.js';
export { CommentsPC } from './pc/comments-pc.js';

var _excluded = ["containerId"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var Comments = function Comments(props) {
  return isGeneralMobile() ? /*#__PURE__*/React__default.createElement(CommentsMobile, _objectSpread({}, props)) : /*#__PURE__*/React__default.createElement(CommentsPC, _objectSpread({}, props));
};
var DEFAULT_COMMENTS_CONTAINER_ID = 'CommentContainer';
var initComments = function initComments(opts) {
  var _opts$containerId = opts.containerId,
      containerId = _opts$containerId === void 0 ? DEFAULT_COMMENTS_CONTAINER_ID : _opts$containerId,
      otherOpts = _objectWithoutProperties(opts, _excluded);

  var container = dom.appendElement(containerId, otherOpts.type === ECommentType.Topic ? 'topic-container' : undefined);
  container.style.position = 'relative';

  if (otherOpts.type === ECommentType.Topic && !isGeneralMobile()) {
    container.style.width = '980px';
    container.style.margin = '0 auto';
    container.style.overflow = 'auto';
  } // eslint-disable-next-line react/no-render-return-value


  var comment = ReactDOM__default.render( /*#__PURE__*/React__default.createElement(Comments, _objectSpread({}, otherOpts)), container);
  return comment;
};
var unmountComments = function unmountComments() {
  var containerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_COMMENTS_CONTAINER_ID;
  var container = document.getElementById(containerId);

  if (!container) {
    return;
  }

  ReactDOM__default.unmountComponentAtNode(container);
  container.remove();
};

export { Comments, initComments, unmountComments };
